<router-outlet></router-outlet>
<app-footer class="footer dark:bg-gray-800"></app-footer>
<!-- Spinner de carga global que se activa desde el emmiter del event service -->
<div class="overlay" *ngIf="MainEventService.loading | async">
  <div class="center">
    <mat-progress-spinner mode="indeterminate" color="accent"></mat-progress-spinner>
  </div>
</div>
